import { render, staticRenderFns } from "./AddHostingLocationInfo.vue?vue&type=template&id=2ab34ada&scoped=true"
import script from "./AddHostingLocationInfo.vue?vue&type=script&lang=js"
export * from "./AddHostingLocationInfo.vue?vue&type=script&lang=js"
import style0 from "./AddHostingLocationInfo.vue?vue&type=style&index=0&id=2ab34ada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab34ada",
  null
  
)

export default component.exports